import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { axiosInstance } from '../helpers'
import {
    ApartmentContract,
    ContractLifecycleStatus,
} from '../models/Company/types'

export interface ContractAlert {
    contract: ApartmentContract
    alert_type: ContractLifecycleStatus
}

const QUERY_KEY = ['contractAlerts']

export const useContractAlerts = (options?: {
    organization?: number
    enabled?: boolean
}) => {
    const params = options?.organization
        ? `?organization=${options.organization}`
        : ''

    const { data, isLoading, refetch } = useQuery<
        AxiosResponse<ContractAlert[]>,
        Error
    >({
        queryKey: [...QUERY_KEY, options?.organization ?? 'property'],
        queryFn: () =>
            axiosInstance.get(`/company/apartment_contract/alerts/${params}`),
        enabled: options?.enabled !== false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    return {
        alerts: data?.data || [],
        isLoadingAlerts: isLoading,
        refetchAlerts: refetch,
    }
}
